import React from 'react';
import TypesOverview from '../../compositions/TypesOverview';

const Types: React.FC = () => {
    return (
        <div>
            <TypesOverview />
        </div>
    );
};

export default Types;
